import { type ReactNode, RefObject, useRef } from "react";

import Box from "ds/components/Box";
import { AriaOnlyText } from "components/AriaOnlyText";

import SlideTransition from "./SlideTransition";
import styles from "./styles.module.css";
import BulkActionsFloatingBarSpacer from "./Spacer";
import { useKeyboardShortcutFocus } from "./useKeyboardShortcutFocus";

type BulkActionsFloatingBarWrapperProps = {
  children: ReactNode;
  isVisible: boolean;
  isFixed?: boolean;
  virtualizedListContainerRef?: RefObject<HTMLElement | null>;
  onHeightChange?: (height: number) => void;
};

const BulkActionsFloatingBarWrapper = ({
  children,
  isVisible,
  isFixed,
  virtualizedListContainerRef,
  onHeightChange,
}: BulkActionsFloatingBarWrapperProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const { focusElementRef, sourceElement } = useKeyboardShortcutFocus({
    wrapperElement: ref.current,
  });

  return (
    <>
      <SlideTransition
        visible={isVisible}
        wrapperRef={ref}
        className={styles.wrapper}
        isFixed={isFixed}
      >
        <AriaOnlyText ref={focusElementRef} tabIndex={-1}>
          {sourceElement ? "Press Control + 2 to move focus back to the previous element" : ""}
        </AriaOnlyText>
        <Box className={styles.panel} direction="column">
          {children}
        </Box>
      </SlideTransition>
      <BulkActionsFloatingBarSpacer
        isVisible={isVisible}
        floatingBlockRef={ref}
        virtualizedListContainerRef={virtualizedListContainerRef}
        onHeightChange={onHeightChange}
      />
    </>
  );
};

export default BulkActionsFloatingBarWrapper;
